export enum GroupType {
  Project = 'Project',
  CustomerCall = 'Customer Call',
  Problem = 'Problem',
}

export const allowedGroupTypes = [GroupType.Project, GroupType.CustomerCall, GroupType.Problem];

export type GroupTab = 'All' | GroupType;

export interface Group {
  groupId: number;
  groupName: string;
  description: string;
  groupType: GroupType;
  memberCount: number;
  createdBy: string;
  createdDate: string;
  lastActive: string;
  imageUrl?: string;
}

export interface GroupChatMessage {
  messageId: number;
  senderId?: string;
  senderName: string;
  senderPhoto?: string;
  createdAt: string;
  messageText: string;
  isOwnMessage: boolean;
  messageType?: string;
  attachmentUrl?: string;
  conversationId?: number;
}

export interface PagedRequest {
  start: number;
  length: number;
  orderColumn: string;
  orderDirection: 'Ascending' | 'Descending';
  search?: string;
  groupType?: GroupType;
}

export interface ApiResponse<T> {
  success: boolean;
  statusCode: number;
  message?: string;
  data: T;
}

export interface PagedResult<T> {
  data: T[];
  recordsFiltered: number;
  recordsTotal: number;
}

export interface UserBasicInfoDto {
  userId?: string;
  name?: string;
  specialtyName?: string;
  availabilityStatus?: string;
  profilePhotoId?: number | string | null;
}

export interface GroupMemberDto {
  userId: string;
  user?: UserBasicInfoDto;
  isAdmin?: boolean;
}

export interface SendSelectedMembersMessagePayload {
  recipientUserIds: string[];
  message: string;
}

export interface GroupDto {
  groupId: number;
  groupName?: string;
  description?: string;
  groupType?: GroupType | string;
  createdBy?: string;
  createdAt: string;
  isActive: boolean;
  isAdmin?: boolean;
  createdByUser?: UserBasicInfoDto;
  members?: GroupMemberDto[];
}

export interface CreateGroupMember {
  userId: string;
  isAdmin: boolean;
}

export interface CreateGroupRequest {
  groupName: string;
  description: string;
  groupType: string;
  members: CreateGroupMember[];
}

export interface CreateGroupDto {
  groupName: string;
  description: string;
  groupType: GroupType;
  memberUserIds: string[];
}
